const RowHeader = ({ start, end }) => {
  return (
    <td className="sticky-col" rowSpan="3">
      {start} - {end}
    </td>
  );
};

export default RowHeader;
